<template>
  <ExternalList
      headline="Due Reminders"
      endpoint="/api/v2/reminders"
      :endpoint-filters="endpointFilters"
      :headlines="headlines"
      :show-list-actions="false"
      :show-checkboxes="false"
      :show-buttons="false"
      :show-pagination="false"
      :page-size-options="null"
      :can-show="() => false"
      :can-destroy="() => false"
  >
    <template v-slot:default="{ row: reminder }">
      <td class="table__ellipsis">
        <router-link :to="'/'+ reminder.attributes.subject_type + '/' +reminder.attributes.subject_id">
          {{ reminder.attributes.subject_name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ reminder.attributes.text }}
      </td>
    </template>

    <template #headline-right>
      <router-link to="project-reminders" class="btn btn-white btn-sm" style="margin-top: 4px;">
        <i class="fa fa-search"></i> Show all
      </router-link>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from "../../../../Panels/Lists/External.vue";
import moment from 'moment'

export default {
  components: {ExternalList},

  props: {
    project: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    endpointFilters() {
      return {project_id: this.project.id, remind_to: moment().format('YYYY-MM-DD'), status: 'unresolved'}
    },

    headlines() {
      return [
        {width: 12, text: 'Subject'},
        {width: 12, text: 'Text'},
      ]
    },
  }
}
</script>
